export default __webpack_public_path__ + "static/media/logoMonchisRedondo.34250bd9.jpg";